/** Row for ChartTooltipContent `formatter`, mirrors the default row layout. */
export default function MetricTooltipRow({
	color,
	label,
	value,
}: {
	color?: string
	label: string
	value: string
}) {
	return (
		<>
			<div
				className='h-2.5 w-2.5 shrink-0 rounded-[2px]'
				style={{ backgroundColor: color }}
			/>
			<div className='flex flex-1 items-center justify-between leading-none'>
				<span className='text-background/50'>{label}</span>
				<span className='ml-1 font-mono font-medium text-background tabular-nums'>
					{value}
				</span>
			</div>
		</>
	)
}
